import request from '@/utils/request'

// 生存环境
export function sendCode (data) {
  return request({
    data: data,
    url: '/old/mobilemsg_send',
    method: 'post'
  })
}
export function valCode (data) {
  return request({
    data: data,
    url: '/old/mobile_login',
    method: 'post'
  })
}

export function getUser (data) {
  return request({
    data,
    url: '/old/api/User',
    method: 'post'
  })
}

// // 开发环境
// export function sendCode (data) {
//   return request({
//     data: data,
//     url: '/test/mobilemsg_send',
//     method: 'post'
//   })
// }
// export function valCode (data) {
//   return request({
//     data,
//     url: '/test/mobile_login',
//     method: 'post'
//   })
// }
// export function getUser (data) {
//   return request({
//     data: data,
//     url: 'test/api/User',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/login.js